import {track} from "@otto-ec/nav_star-track/";

export class BrandIndexHeadline extends HTMLElement {
    static customElementName = "nav-brand-index-headline";

    constructor () {
        super();
    }

    connectedCallback () {
        this.querySelectorAll('nav-refer-back')
            .forEach(b =>
                b.addEventListener('click', e =>
                    track(e.target, 'user-action/click-back-button')));
    }
}
